import React from 'react';
import PropTypes from 'prop-types';

const DateFromMillis = (props) => {
  const { millis } = props;
  const date = new Date(parseInt(millis, 10));

  return (
    <div>
      {`${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`}
    </div>
  );
};

DateFromMillis.propTypes = {
  millis: PropTypes.string,
};

DateFromMillis.defaultProps = {
  millis: '0',
};

export default DateFromMillis;
